export enum LocalStorageKeys {
  VERSION = 'version',
  SETTING = 'setting',
  ITEM_LISTING_SEARCH = 'item_listing_search',
}

export const LOCAL_STORAGE_VERSION =
  process.env.NEXT_PUBLIC_LOCAL_STORAGE_VERSION
